var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M9 4v6l-2 4v2h10v-2l-2-4V4m-3 12v5M8 4h8"
    }, null, -1)
  ]));
}
__name(render, "render");
const pinned = markRaw({ name: "tabler-pinned", render });
export {
  pinned as default
};
//# sourceMappingURL=pinned.js.map
